export const projectsArr = [
  {
    name: "Porfolio Website",
    desc: "A portfolio website built using React and StyledCompnents.",
    gh: "https://github.com/bagfaceasadkhan/selfportfolio",
    live: "https://bagfaceasadkhan.github.io/selfportfolio/",
  },
  {
    name: "JuiceIt",
    desc: "A landing page for an imaginary juice shop using React.",
    gh: "https://github.com/bagfaceasadkhan/JuiceIt",
    live: "https://bagfaceasadkhan.github.io/JuiceIt/",
  },
  {
    name: "CryptoApp",
    desc: "Crypto tracking app built using React and styled components.",
    gh: "https://github.com/bagfaceasadkhan/bagfacecrypto",
    live: "https://bagfaceasadkhan.github.io/bagfacecrypto/",
  },
  {
    name: "TeslaClone",
    desc: "A tesla website clone build using React.",
    gh: "https://github.com/bagfaceasadkhan/tesla-clone",
    live: "",
  },
];
